<a class="router-link" [routerLink]="route" routerLinkActive="router-link__active">
  <hp-icons [name]="name"></hp-icons>  <span class="router-link__name">{{name}}</span>
</a>
